import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "m10.586 5.414-5.172 5.172"
}), ___EmotionJSX("path", {
  d: "m18.586 13.414-5.172 5.172"
}), ___EmotionJSX("path", {
  d: "M6 12h12"
}), ___EmotionJSX("circle", {
  cx: "12",
  cy: "20",
  r: "2"
}), ___EmotionJSX("circle", {
  cx: "12",
  cy: "4",
  r: "2"
}), ___EmotionJSX("circle", {
  cx: "20",
  cy: "12",
  r: "2"
}), ___EmotionJSX("circle", {
  cx: "4",
  cy: "12",
  r: "2"
}));
export default SVG;